export enum LoginDevice {
    SCANNER = "SCANNER", 
    SILIZHU = "SILIZHU"
}